import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export type FilterTab = {
  id: string;
  label: string;
  count?: number;
};

@Component({
  selector: 'app-filter-tabs',
  templateUrl: './filter-tabs.component.html',
  styleUrls: ['./filter-tabs.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class FilterTabsComponent {
  @Input() tabs: FilterTab[] = [];

  @Input() activeTab!: string;

  @Output() tabChange = new EventEmitter<string>();

  select(id: string): void {
    if (this.activeTab === id) return;
    this.tabChange.emit(id);
  }

  /** Hosts often rebuild the tabs array; the same id is the same button. */
  trackById(_index: number, tab: FilterTab): string {
    return tab.id;
  }
}
